/*
 * 组件集市API
 * */
import services from "../config/axios";
import base from "./base";

const componentManageAPI = {
    // 获取类别
    getComClassLabel<T>(params: FormData) {
        return services.post(`${base.lk}/Component/GetComClassLabel`, params);
    },
    // 新增应用
    addAPP<T>(params: FormData) {
        return services.post(`${base.lk}/Component/AddAPP`, params);
    },
    // 删除应用
    delAPP<T>(params: FormData) {
        return services.post(`${base.lk}/Component/DelAPP`, params);
    },
    // 更新应用
    updateAPP<T>(params: FormData) {
        return services.post(`${base.lk}/Component/UpdateAPP`, params);
    },
    submitAPP<T>(params: FormData) {
        return services.post(`${base.lk}/Component/SubmitAPP`, params);
    },
    // 获取组件集市列表
    getComponentsList<T>(params: FormData) {
        return services.post(`${base.lk}/Component/GetComponentsList`, params);
    },
    //获取一个APP信息
    getComponentOne<T>(params: FormData) {
        return services.post(`${base.lk}/Component/GetComponentOne`, params);
    },
    //检查APP是否有附件
    checkComponentHasFiles<T>(params: FormData) {
        return services.post(
            `${base.lk}/Component/CheckComponentHasFiles`,
            params
        );
    },
    //更新MCP版本
    updateAppVersion<T>(params: FormData) {
        return services.post(`${base.lk}/Component/UpdateAppVersion`, params);
    },
    //获取版本列表
    getPackageList<T>(params: FormData) {
        return services.post(`${base.lk}/Component/GetPackageList`, params);
    },
};

export default componentManageAPI;
